import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

export { useUrlAssetScope } from './useUrlAssetScope'

const SCOPE_KEYS = {
  siteId: 'siteID',
  assetId: 'assetID'
}

function setParams (params, changes, keyMap = {}) {
  Object.entries(changes).forEach(([property, value]) => {
    const key = keyMap[property] ?? property

    if (value === null || value === undefined || value === '') {
      params.delete(key)
    } else {
      params.set(key, String(value))
    }
  })
}

export function buildScopedSearch (
  search, 
  scope = {}, 
  extraParams = {}) {
  const params = new URLSearchParams(search)

  setParams(params, scope, SCOPE_KEYS)
  setParams(params, extraParams)

  return params.toString()
}

export function useScopedNavigate () {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(
    (pathname, { scope = {}, params = {}, replace = false } = {}) => {
      const query = buildScopedSearch(location.search, scope, params)

      navigate(
        {
          pathname,
          search: query ? `?${query}` : ''
        },
        { replace }
      )
    },
    [location.search, navigate]
  )
}
